<template>
    <TransitionHeight
        :visable="visable"
        :contentClass="[
            'bg-black ease-in-out duration-300',
            !visable ? 'translate-x-[100%] opacity-0' : '',
            call ? 'w-[404px]' : 'w-[340px]',
        ]"
    >
        <div class="flex items-start justify-between py-3 pl-6 pr-4">
            <p class="text-white text-15 pr-4" :class="[call ? 'font-hero font-bold text-19' : '']">{{ title }}</p>

            <button class="pt-[4px]" @click="remove" v-if="!call || (call && (title == 'Missed call' || title == 'Call complete'))">
                <IconClose class="h-4.5 w-4.5 stroke-white" />
            </button>
        </div>

        <div v-if="call" class="text-white bg-white/10 p-6 flex items-center justify-between">
            <div>
                <p class="text-17 font-semibold">{{ call.name }}</p>
                <p class="text-grey-800 text-14">{{ $help.e164ToNumber(call.from || call.To) }}</p>
            </div>

            <div class="flex gap-2">
                <button
                    class="w-10 h-10 rounded-full bg-green-600 flex items-center justify-center hover:cursor-pointer hover:bg-green-500 disabled:hover:bg-white/20 disabled:bg-white/20 disabled:cursor-default"
                    @click="call.accept()"
                    v-if="call.callStatus.status == 'Incoming'"
                >
                    <IconPhone class="w-4.5 h-4.5 stroke-white" />
                </button>

                <NuxtLink
                    :to="call.link"
                    class="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:cursor-pointer hover:bg-white/20"
                    v-if="call.link != null"
                >
                    <IconUser class="w-4.5 h-4.5 stroke-white" />
                </NuxtLink>

                <button
                    class="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:cursor-pointer hover:bg-white/20"
                    @click="call.toggleMute()"
                    v-if="call.callStatus.status == 'Accepted'"
                >
                    <component :is="call.callStatus.muted ? 'IconMute' : 'IconVoiceSearch'" class="w-4.5 h-4.5 stroke-white" />
                </button>

                <button
                    class="w-10 h-10 rounded-full bg-red-700/80 flex items-center justify-center hover:cursor-pointer hover:bg-red-700 disabled:hover:bg-white/20 disabled:bg-white/20 disabled:cursor-default"
                    @click="ignore"
                    :disabled="!(call.callStatus.status == 'Incoming' || call.callStatus.status == 'Accepted')"
                    v-if="call.callStatus.status != 'Calling' && call.callStatus.status != 'Cancelled'"
                >
                    <IconClose class="w-4.5 h-4.5 stroke-white" />
                </button>
            </div>
        </div>
        <div class="h-[5px] w-full bg-grey-800" v-if="!call">
            <div class="h-[5px] bg-grey-900 toast-progress" />
        </div>
    </TransitionHeight>
</template>

<script>
export default {
    props: {
        message: [String, Object, Array],
        call: Object,
    },
    data() {
        return {
            visable: false,
        }
    },
    mounted() {
        // this.hidden = false
        setTimeout(() => {
            this.visable = true
        }, 100)

        if (!this.call) {
            setTimeout(() => {
                this.visable = false
            }, 7100)
        }

        this.$event.$on('toast-call-hide', (id) => {
            if (this.call.id == id) {
                this.visable = false
            }
        })
    },
    methods: {
        remove() {
            this.visable = false
        },
        ignore() {
            this.call.ignore()
            this.remove()
        },
    },
    computed: {
        title() {
            if (!this.call) {
                return this.message
            }
            return this.call.callStatus.readableStatus
        },
    },
}
</script>
